


























































































































import {Component, Vue, Ref, Prop} from 'vue-property-decorator';
import { AccountModule } from '@/store/modules/account';
import RecordsModal from './recordsModal.vue';
import OperationModal from './operationModal.vue';
import ReviewModal from './reviewModal.vue';
import { todoListInstance } from '@/model/TodoListClass';
import { Pagination } from 'ant-design-vue';
import {titleColumn, moduleColumn, dueColumn, manDayColumn, isBonusColumn} from '../column';

type ITodoInfo = ITodo.IResponse.ITodoInfo;



@Component({
  components: {
    RecordsModal,
    OperationModal,
    ReviewModal,
  },
})
export default class TodoList extends Vue {
  @Ref() private readonly recordsModal!: RecordsModal;
  @Ref() private readonly operationModal!: OperationModal;
  @Ref() private readonly reviewModal!: ReviewModal;
  @Prop({default: false}) private spinning!: boolean;
  private tabActiveKey = 'ALL';
  private addLoading: boolean = false;
  private pagination = {
    current: 1,
    pageSize: 15,
    hideOnSinglePage: true,
  };
  private searchInput = null;
  private searchText = '';
  private searchedColumn = '';
  private todoListInstance = todoListInstance;
  get userId() {
    return AccountModule.userDetailInfo?.id;
  }
  get currentTodo() {
    return this.todoListInstance.list.current;
  }
  get activeId(): string {
    return this.currentTodo?.id || '';
  }
  get isMore(): boolean {
    return this.todoListInstance.isMore;
  }
  get todoListData(): ITodoInfo[] {
    return this.todoListInstance.list.data;
  }
  get totalPageCount() {
    return Math.ceil(this.todoListData.length / this.pagination.pageSize);
  }
  get isLastPage() {
    return this.pagination.current >= this.totalPageCount;
  }
  get dataByProjectCategory() {
    if (this.tabActiveKey === 'ALL') {
      return this.todoListData;
    }
    return this.todoListData.filter((todo) => todo.projectId === this.tabActiveKey);
  }
  get projects(): ITodo.IOptionInfo[] {
    const userProjects = AccountModule.projects.map((project) => ({value: project.id, text: project.name}));
    const otherProjects: ITodo.IOptionInfo[] = [];
    todoListInstance.projectOption.forEach((project) => {
      if (userProjects.findIndex((userProject) => userProject.value === project.value) <= -1) {
        otherProjects.push(project);
      }
    });
    return [
      {value: 'ALL', text: 'All Project'},
      ...userProjects,
      ...otherProjects,
    ];
  }
  get columns() {
    const typeColumn = {
      key: 'type',
      dataIndex: 'typeName',
      width: '8%',
      slots: { title: 'typeTitle' },
      filters: todoListInstance.typeOption,
      onFilter: (value: string, record: ITodoInfo) => {
        return record.typeId === value;
      },
    };
    const ownerColumn = {
      dataIndex: 'ownerName',
      slots: { title: 'ownerTitle' },
      scopedSlots: { customRender: 'owner' },
      width: '8%',
      filters: todoListInstance.ownerOption,
      onFilter: (value: string, record: ITodoInfo) => {
        if (value === 'Null') {
          return record.owner === null;
        }
        return record.owner === value;
      },
    };
    const statusColumn = {
      dataIndex: 'status',
      slots: { title: 'statusTitle' },
      width: '8%',
      align: 'center',
      defaultFilteredValue: ['Processing', 'Completed', 'Closed'],
      filters: todoListInstance.statusOption,
      onFilter: (value: string, record: ITodoInfo) => record.status === value,
    };
    const settlementUnitColumn = {
      dataIndex: 'settlementConfigurationName',
      slots: { title: 'settlementUnitTitle' },
      width: '8%',
      align: 'center',
      filters: todoListInstance.settlementUnitOption,
      onFilter: (value: string, record: ITodoInfo) => record.settlementConfigurationId === value,
    };
    const actionColumn = {
      key: 'action',
      slots: { title: 'actionTitle' },
      scopedSlots: { customRender: 'action' },
      width: '15%',
      filters: [
        {text: this.$t('todo.checkIn'), value: 'CheckIn'},
        {text: this.$t('todo.checkOut'), value: 'CheckOut'},
        {text: this.$t('todo.complete'), value: 'Complete'},
        {text: this.$t('todo.termination'), value: 'Termination'},
        {text: this.$t('todo.delete'), value: 'Revoke'},
        {text: this.$t('todo.check'), value: 'Check'},
      ],
      onFilter: (value: string, todo: ITodoInfo) => {
        const isTodoOwner = this.isTodoOwner(todo);
        if (value === 'Check') {
          return todo.status === 'Completed';
        } else if (value === 'Revoke') {
          return todo.records.length === 0 || todo.status === 'Closed';
        } else if (value === 'Termination') {
          return todo.status !== 'Closed' && todo.status !== 'Reviewed';
        } else if (value === 'CheckIn') {
          return isTodoOwner && todo.status === 'Processing' && todo.isChecedOut;
        } else if (value === 'CheckOut') {
          return isTodoOwner && todo.status === 'Processing' && !todo.isChecedOut;
        } else if (value === 'Complete') {
          return isTodoOwner && todo.status === 'Processing' && todo.records.length !== 0 && todo.isChecedOut;
        }
        return false;
      },
    };
    const patternTypeColumn = {
      dataIndex: 'patternType',
      slots: { title: 'patternTypeTitle' },
      scopedSlots: { customRender: 'patternType' },
      width: '4%',
      align: 'center',
    };
    return [
      titleColumn,
      moduleColumn,
      typeColumn,
      ownerColumn,
      patternTypeColumn,
      dueColumn,
      statusColumn,
      manDayColumn,
      settlementUnitColumn,
      isBonusColumn,
      actionColumn,
    ];
  }
  private isTodoOwner(todo: ITodoInfo) {
    return AccountModule.userDetailInfo?.id === todo.owner;
  }
  private handleTableChange(pagination: Pagination) {
    this.pagination.current = pagination.current!;
  }
  private clickTodo(todo: ITodoInfo) {
    todoListInstance.list.changeCurrent(todo);
  }
  private getRowClassName(todo: ITodoInfo, index: number): string {
    if (todo.id === this.activeId) {
      return 'active';
    }
    return '';
  }
  private customRow(todo: ITodoInfo, index: number) {
    return {
      on: {
        click: (event: Event) => {
          this.clickTodo(todo);
        },
      },
    };
  }
  private handleCheckIn(todo: ITodoInfo) {
    this.clickTodo(todo);
    todoListInstance.requestCheckInTodo(todo).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleCheckOut(todo: ITodoInfo) {
    this.clickTodo(todo);
    todoListInstance.requestCheckOutTodo(todo).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleComplete(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.$confirm({
      title: this.$t('operation.confirmMsg', {
        operation: this.$t('todo.complete'),
      }).toString(),
      onOk: () => {
        this.updateStatus(todo, 'Completed');
      },
    });
  }
  private handleReview(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.reviewModal.showVisible({
      todo,
      activeKey: 'check',
    });
  }
  private handleChangeValue(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.reviewModal.showVisible({
      todo,
      activeKey: 'change',
    });
  }
  private handleTrans(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.reviewModal.showVisible({
      todo,
      activeKey: 'trans',
    });
  }
  private handleClose(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.operationModal.showVisible({
      title: this.$t('operation.confirmMsg', {operation: this.$t('todo.termination')}).toString(),
      activeKey: 'close',
      todo,
    });
  }
  private updateStatus(todo: ITodoInfo, status: ITodo.ITodoStatus, comment?: string) {
    todoListInstance.requestUpdateTodoStatus(todo, status, comment).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    });
  }
  private handleDelete(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.operationModal.showVisible({
      title: this.$t('operation.confirmMsg', {operation: this.$t('todo.delete')}).toString(),
      activeKey: 'delete',
      todo,
    });
  }
  private showRecords(todo: ITodoInfo) {
    this.clickTodo(todo);
    this.recordsModal.showVisible(todo.records);
  }
  private goModulePage(moduleId: string) {
    this.$router.push({
      name: 'Module',
      params: {
        id: moduleId,
      },
    });
  }
  private handleSearch(selectedKeys: string[], confirm: () => void, dataIndex: string) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = dataIndex;
  }
  private handleReset(clearFilters: () => void) {
    clearFilters();
    this.searchText = '';
  }
  private tabsChange(activeKey: string) {
    this.pagination.current = 1;
  }
}
